import { CoordinatorService } from './coordinator.service';
export class RatingConnector {
    constructor(
        private coords: CoordinatorService,
        private xitmId: string,
    ) {}
}

export class TagConnector {
    constructor(
        private coords: CoordinatorService,
        private xitmId: string,
    ) {}
}

export class SubsetConnector {
    constructor(
        private coords: CoordinatorService,
        private xitmId: string,
    ) {}

    has(key: string): boolean {
        key = this.coords.utils$.normalizeString(key);
        for (const v of this.coords.view$.sortedViewLs)
            if (this.coords.utils$.normalizeString(v.title) === key) return v.has(this.xitmId);
        return false;
    }
}
